import WarrantyRibbon from "@components/Icons/WarrantyRibbon";
import Tooltip from "@components/Tooltip";

const tooltipContent = {
  garantie_comerciala_global: "pentru persoane juridice",
  garantie_conformitate_global: "pentru persoane fizice",
};

const Warranty = ({ data }) =>
  data.map((warranty, index) => (
    <div
      className="Warranty-info flex justify-start items-center u-border-dotted"
      key={index}
    >
      <div className="Warranty-icon mr-1 w-4 h-4">
        <WarrantyRibbon />
      </div>

      <div className="Warranty-info text-black text-xs leading-[14px]">
        <span className="Warranty-label">{warranty.label}</span>
        {": "}
        <span className="Warranty-qty font-bold">{warranty.value}</span>
      </div>

      {tooltipContent[warranty.attribute_code] && (
        <div className="ml-2">
          <Tooltip content={tooltipContent[warranty.attribute_code]} />
        </div>
      )}
    </div>
  ));

export default Warranty;
